import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 1B01BAE0-095E-424E-9552-6ECEF5E4FC62
 * name heart-half
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/heart-half.svg
 * tags
 * - Gaming / RPG 
 */
export const HeartHalfIcon = createSvgIcon(<><path d="M13,7.2V17.74L13,20.44L12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C10,3 13,5 13,7.2Z" /></>, 'HeartHalfIcon');
export default HeartHalfIcon